/**
 * Created by slava on 06.07.2023
 */

const DiceView = cc.Node.extend({
    ctor: function (dice) {
        this._super();
        this.dice = dice;
        const style = cleverapps.styles.Dice;

        const view = this.view = new cleverapps.Spine(bundles.dices.jsons.roll_animation);
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(view.getContentSize());
        view.setPosition(this.width / 2, this.height / 2);
        this.addChild(view);

        const choose = this.choose = cleverapps.UI.createScale9Sprite(bundles.slots.frames.choose);
        choose.setContentSize2(style.choose);
        choose.setAlignment(style.choose.position);
        this.addChild(choose, -1);
        choose.setVisible(false);

        cleverapps.UI.onClick(this, this.createListener(dice.onClick.bind(dice)));

        this.setVisible(false);

        if (this.dice.score) {
            this.animateRoll(this.dice.score);
        }

        if (this.dice.chosen) {
            this.animateChoose(this.dice.chosen);
        }

        this.dice.on("changeChosen", this.animateChoose.bind(this), this);
        this.dice.on("roll", this.animateRoll.bind(this), this);
        this.dice.on("hide", this.animateHide.bind(this), this);
        this.dice.on("flight", this.animateFlight.bind(this), this);
        this.dice.on("highlight", this.animateHighlight.bind(this), this);

        cleverapps.aims.registerTarget(`dice${this.dice.id}`, this);
    },

    animateChoose: function (chosen) {
        this.choose.setVisible(chosen);

        cleverapps.audio.playSound(bundles.game.urls.pick);
    },

    animateRoll: function (previousScore, cb) {
        const isInitialRoll = !this.visible;

        this.removeMark();

        this.runAction(
            cc.sequence(
                cc.delayTime(isInitialRoll ? this.dice.id * 0.1 : 0),
                cc.callFunc(() => {
                    this.setVisible(true);
                    this.view.setSkin(`${previousScore} to ${this.dice.score}`);

                    this.view.setAnimation(0, isInitialRoll ? "finish" : "start", false);

                    let after = 1;
                    if (!isInitialRoll) {
                        this.view.addAnimation(0, "finish", false);
                        after++;
                    }

                    this.view.setCompleteListener(() => {
                        if (--after === 0) {
                            this.addMark();
                            this.view.setCompleteListener();

                            if (cb) {
                                cb();
                            }
                        }
                    });
                })
            )
        );
    },

    addMark: function () {
        if (this.dice.mark) {
            this.markView = new MarkView(this.dice.mark);
            this.addChild(this.markView);
        }
    },

    removeMark: function () {
        if (this.markView) {
            this.markView.removeFromParent(true);
            this.markView = undefined;
        }
    },

    animateHide: function (silent) {
        const index = this.dice.id;

        if (!this.visible) {
            return;
        }

        if (silent) {
            this.setVisible(false);
            return;
        }

        this.runAction(
            new cc.Sequence(
                new cc.DelayTime((4 - index) * 0.05),
                cc.spawn(
                    cc.sequence(
                        cc.scaleTo(0.05, 1.2),
                        cc.scaleTo(0.15, 0.3)
                    )
                ),
                new cc.CallFunc(() => {
                    this.setVisible(false);
                })
            )
        );
    },

    animateFlight: function (slot, callback) {
        const index = this.dice.id;
        const flightDice = this.getFlightDice();
        const target = cleverapps.aims.getTarget(`slot${slot.id}`);

        flightDice.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode());
        flightDice._setGlobalZOrder(true);

        const pos = flightDice.parent.convertToNodeSpace(target.parent.convertToWorldSpace(target.getPosition()));
        const points = [flightDice.getPosition(), cc.p((flightDice.x + pos.x) / 2, (flightDice.y + pos.y) / 2), pos];

        const actions = [
            new cc.CallFunc(() => {
                this.setVisible(false);
            }),
            new cc.CallFunc(() => {
                flightDice.setAnimation(0, "animations", false);
            }),
            new cc.BezierTo(0.5, points).easing(cc.easeIn(1)),
            new cc.CallFunc(() => {
                if (index === 0) {
                    slot.collect();
                }

                if (index === 4) {
                    callback();
                }
            }),
            new cc.RemoveSelf()
        ];

        flightDice.runAction(new cc.Sequence(actions));
    },

    animateHighlight: function (cb) {
        const score = this.dice.score;
        this.view.setVisible(false);
        const highlight = new cleverapps.Spine(bundles.dices.jsons.roll_animation);
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(highlight.getContentSize());
        highlight.setPosition(this.width / 2, this.height / 2);
        this.addChild(highlight);
        highlight.setSkin(`highlight${score}`);
        highlight.setAnimation(0, "highlight_dice", false);
        highlight.setCompleteListenerRemove(() => {
            this.view.setVisible(true);
            cb && cb();
        });
    },

    getFlightDice: function () {
        const flightDice = new cleverapps.Spine(bundles.dices.jsons.flight_animation);
        flightDice.setSkin(`cube_${this.dice.score}`);
        flightDice.setAlignment(this.width / 2, this.height / 2);
        this.addChild(flightDice);

        return flightDice;
    },

    wiggleOn: function () {
        this.view.runAction(
            cc.repeatForever(
                cc.sequence(
                    cc.rotateTo(0.2, -5).easing(cc.easeIn(1)),
                    cc.rotateTo(0.2, 5).easing(cc.easeOut(1))
                )
            )
        );
    },

    wiggleOff: function () {
        this.view.stopAllActions();
        this.view.setRotation(0);
    }
});

cleverapps.styles.Dice = {
    choose: {
        width: 165,
        height: 165,
        position: {
            x: { align: "center" },
            y: { align: "center" }
        }
    }
};